import { Action } from "../Actions";
import { DEFAULT_CONTACT_TYPE } from "../../constants";

const TYPE_MESSAGE = "TYPE_MESSAGE";
const RESET_MESSAGE = "RESET_MESSAGE";
const CHANGE_CONTACT_TYPE = "CHANGE_CONTACT_TYPE";
const CHANGE_UPLOADING_STATE = "CHANGE_UPLOADING_STATE";
const ADD_MEDIA = "ADD_MEDIA";
const SET_TYPING_DATA = "SET_TYPING_DATA";

const initialState: MessagesState = {
  currentMessage: {},
  contactType: DEFAULT_CONTACT_TYPE,
  uploading: false,
  typing: null,
};

export interface MessagesState {
  currentMessage: any;
  contactType: number;
  uploading: boolean;
  typing: any;
}

export class MessagesActions {
  static setTypingState = (typingData: any): Action => ({
    type: SET_TYPING_DATA,
    payload: { typingData },
  });
  static typeMessage = (text: string): Action => ({
    type: TYPE_MESSAGE,
    payload: { text: text },
  });
  static resetMessage = (): Action => ({ type: RESET_MESSAGE, payload: {} });
  static addMedia = (media: string): Action => ({
    type: ADD_MEDIA,
    payload: { media: media },
  });
  static changeContactType = (type: number): Action => ({
    type: CHANGE_CONTACT_TYPE,
    payload: { type: type },
  });
  static changeUploadingState = (uploading: boolean): Action => ({
    type: CHANGE_UPLOADING_STATE,
    payload: { uploading: uploading },
  });
}

export function reduce(state: MessagesState = initialState, action: Action) {
  switch (action.type) {
    case SET_TYPING_DATA: {
      return {
        ...state,
        ...{
          typing: action.payload?.typingData || null,
        },
      };
    }

    case TYPE_MESSAGE: {
      const text = action.payload?.text || "";

      return {
        ...state,
        ...{
          currentMessage: {
            ...state.currentMessage,
            text: text,
            // mediaUrl
          },
        },
      };
    }

    case RESET_MESSAGE: {
      return {
        ...state,
        ...{
          currentMessage: {
            text: "",
          },
          uploading: false,
        },
      };
    }

    case ADD_MEDIA: {
      const media = action.payload?.media || null;

      return {
        ...state,
        ...{
          currentMessage: {
            ...state.currentMessage,
            mediaUrl: media,
          },
        },
      };
    }

    case CHANGE_CONTACT_TYPE: {
      return {
        ...state,
        ...{
          contactType: action.payload.type,
        },
      };
    }

    case CHANGE_UPLOADING_STATE: {
      return {
        ...state,
        ...{
          uploading: action?.payload?.uploading || false,
        },
      };
    }

    default:
      return state;
  }
}
